import { render } from "./UnNftAssetDetail.vue?vue&type=template&id=e88fe200"
import script from "./UnNftAssetDetail.vue?vue&type=script&lang=js"
export * from "./UnNftAssetDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__